import React, { useEffect, useState } from "react";
import FlashMessage from "./FlashMessage";
import { clearPersistedAlert, consumePersistedAlert, subscribeToAgentAlerts } from "../../lib/alerts";

const ERROR_TYPES = new Set(["danger", "error", "warning"]);

export default function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const persisted = consumePersistedAlert();
    if (persisted) {
      setAlert({ ...persisted, id: Date.now() });
    }

    return subscribeToAgentAlerts((nextAlert) => {
      setAlert({ ...nextAlert, id: Date.now() });
    });
  }, []);

  return (
    <>
      {children}
      <div className="agent-alert-host" aria-live="polite" aria-atomic="true">
        {alert?.message ? (
          <FlashMessage
            key={alert.id}
            type={alert.type}
            message={alert.message}
            duration={ERROR_TYPES.has(alert.type) ? 7000 : 3500}
            className="mb-0 agent-alert-toast"
            onClose={() => {
              clearPersistedAlert();
              setAlert(null);
            }}
          />
        ) : null}
      </div>
    </>
  );
}
